import * as React from "react";
import {Col, Row} from "react-bootstrap";
import {CrossSell} from "../../../../components/crossSell";
import {useAddToCartRecommendations} from "../../../../hooks/useAddToCartRecommendations";

export const Recommendations = () => {
    const {models} = useAddToCartRecommendations();

    // If there are no cross-sells, don't render the carousel
    if (!models || models.length < 1) return <></>;

    return (
        <Row className="bg-light py-3" style={{minHeight: '800px'}}>
            <Col>
                <h2 className="fs-5 fw-normal">Users Who Bought Also Bought</h2>
                <Row>
                    {models.map((crossSell, index) => <Col key={index} xs={6} className="mt-2"><CrossSell
                        model={crossSell} index={index}/></Col>)}
                </Row>
            </Col>
        </Row>
    )
};